import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { useTranslation } from 'react-i18next';
import { SegmentedControl, Button, IconSvg, helperMargin, Typography } from '@utex/ui-kit';
import { getExtraDimHeaderButton, getPrimaryDimHeaderButton, } from '../../../HeaderButtons/buttonsView';
import { Wrapper, Line, Accounts } from './styles';
import { MoneyView } from '../../../MoneyView';
export var BalanceTooltip = function (_a) {
    var openDeposit = _a.openDeposit, openWithdraw = _a.openWithdraw, onAccountsClick = _a.onAccountsClick, view = _a.view, isTooltipVisible = _a.isTooltipVisible, free = _a.free, investedSum = _a.investedSum, grossSum = _a.grossSum;
    var t = useTranslation('header').t;
    return (React.createElement(CSSTransition, { in: isTooltipVisible, timeout: 300, unmountOnExit: true, classNames: "mount" },
        React.createElement(Wrapper, null,
            React.createElement("div", null,
                React.createElement(Line, null,
                    React.createElement(Typography.Text, null, t('My portfolio'))),
                React.createElement(Line, null,
                    React.createElement(Typography.Text, null, t('Free')),
                    React.createElement(Typography.Text, null,
                        React.createElement(MoneyView, { rule: "0-2" }, free))),
                React.createElement(Line, null,
                    React.createElement(Typography.Text, null, t('Invested')),
                    React.createElement(Typography.Text, null,
                        React.createElement(MoneyView, { rule: "0-2" }, investedSum))),
                React.createElement(Line, null,
                    React.createElement(Typography.Text, null, t('Current Profit')),
                    React.createElement(Typography.Text, null,
                        React.createElement(MoneyView, { sign: "always", rule: "0-2" }, grossSum))),
                React.createElement(Line, null,
                    React.createElement(Accounts, { href: "/account", onClick: function (e) {
                            e.preventDefault();
                            onAccountsClick();
                        } }, t('All accounts')))),
            React.createElement(SegmentedControl, null,
                React.createElement(Button, { as: "a", view: getPrimaryDimHeaderButton('default'), isBlured: view !== 'default', onClick: function (e) {
                        e.preventDefault();
                        openDeposit();
                    }, "data-gtm": "deposit-btn" },
                    React.createElement(IconSvg, { src: "plus-thin", width: 16, height: 16, css: helperMargin({ right: 10 }) }),
                    t('Deposit')),
                React.createElement(Button, { as: "a", view: getExtraDimHeaderButton('default'), isBlured: view !== 'default', onClick: function (e) {
                        e.preventDefault();
                        openWithdraw();
                    } },
                    React.createElement(IconSvg, { src: "minus-thin", width: 16, height: 16, css: helperMargin({ right: 10 }) }),
                    t('Withdraw'))))));
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/UserBlock/components/BalanceTooltip/index.js
// module id = 1367
// module chunks = 118